module.exports = __webpack_public_path__ + "static/media/01yamanote.26e9c184.png";